import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { catchError, forkJoin, lastValueFrom, map, of, switchMap, tap } from "rxjs";
import {
  Game,
  HomeRanks,
  Rest,
  RoadRanks,
  RosterList,
  ScorePronos,
  Standings
} from "src/app/models/games/games.models";
import { AverageStat } from "src/app/models/games/team-stats.model";
import { MathsService } from "src/app/services/maths/maths-service";
import { StatsService } from "src/app/services/stats/stats-service";
import { TrelloService } from "src/app/services/trello/trello.service";

@Component({
  selector: "app-accueil",
  templateUrl: "./accueil.component.html",
  styleUrls: ["./accueil.component.scss"],
})
export class AccueilComponent implements OnInit {
  date = this.datePipe.transform(
    new Date().setDate(new Date().getDate() - 1),
    "yyyy/MM/dd"
  );
  game: Game;
  // last = "13";
  gameDay: string;
  homeTeamStats: AverageStat = null;
  roadTeamStats: AverageStat = null;
  homeStanding: Standings = null;
  roadStanding: Standings = null;
  homeStandingAll: Standings = null;
  roadStandingAll: Standings = null;
  road = "road";
  home = "home";

  homeSimulationPoints: string = null;
  roadSimulationPoints: string = null;
  roadInfos: string[];
  homeInfos: string[];
  homeRanks: HomeRanks;
  roadRanks: RoadRanks;
  rosterListHome: RosterList;
  homeRest: Rest;
  roadRest: Rest;
  homeStreak: string;
  roadStreak: string;
  homeBTB: string;
  roadBTB: string;
  homeScoringPosition: any;
  roadScoringPosition: any;
  gameScoring: ScorePronos;

  constructor(
    private statsService: StatsService,
    private mathService: MathsService,
    private route: ActivatedRoute,
    private trelloService: TrelloService,
    private datePipe: DatePipe
  ) {}

  async ngOnInit() {
  const id = this.route.snapshot.params['id'];

  const game$ = this.statsService.getCurrentGameList().pipe(
    map(gameList => gameList[id]),
    tap(game => {
      this.game = game;
      this.gameDay = this.datePipe.transform(game.date, 'MM/dd/yyyy')!;
    })
  );

  await lastValueFrom(
    game$.pipe(
      switchMap(game => {
        const ddMMyyyy = this.datePipe.transform(game.date, 'dd/MM/yyyy')!;
        const mmddyyyy = this.datePipe.transform(game.date, 'MM/dd/yyyy')!;

        const homeTeam = game.homeTeam;
        const roadTeam = game.roadTeam;

        return forkJoin({
          // ===== STATS =====
          standingsHome: this.statsService.getStandings(homeTeam, ddMMyyyy),
          standingsRoad: this.statsService.getStandings(roadTeam, ddMMyyyy),
          standingsHomeAll: this.statsService.getStandings(homeTeam, ddMMyyyy, "all"),
          standingsRoadAll: this.statsService.getStandings(roadTeam, ddMMyyyy,"all"),

          restRoad: this.statsService.getRest(roadTeam, mmddyyyy),
          restHome: this.statsService.getRest(homeTeam, mmddyyyy),

          streakHome: this.statsService.getStreak(homeTeam, mmddyyyy),
          streakRoad: this.statsService.getStreak(roadTeam, mmddyyyy),

          scoring: this.statsService.getScoring(game.id),

          ranksHome: this.statsService.getRanks(
            this.statsService.getCorrectName(homeTeam)
          ),
          ranksRoad: this.statsService.getRanks(
            this.statsService.getCorrectName(roadTeam)
          ),

          scoringPosRoad: this.statsService.getScoringPosition(
            this.statsService.getCorrectName(roadTeam)
          ),
          scoringPosHome: this.statsService.getScoringPosition(
            this.statsService.getCorrectName(homeTeam)
          ),

          // ===== TRELLO =====
          // trelloHome: this.trelloService.getCardsByList(homeTeam),
          // trelloRoad: this.trelloService.getCardsByList(roadTeam),
        }).pipe(
          tap(res => {
            // ===== STANDINGS =====
            this.homeStanding = res.standingsHome;
            this.roadStanding = res.standingsRoad;
            this.homeStandingAll = res.standingsHomeAll;
            this.roadStandingAll = res.standingsRoadAll;

            // ===== REST =====
            this.roadRest = res.restRoad;
            this.homeRest = res.restHome;
            this.roadBTB = res.restRoad.isBackToBack ? '| B2B' : '| +1';
            this.homeBTB = res.restHome.isBackToBack ? '| B2B' : '| +1';

            // ===== STREAKS =====
            this.homeStreak = res.streakHome.win
              ? `W${res.streakHome.streak}`
              : `L${res.streakHome.streak}`;

            this.roadStreak = res.streakRoad.win
              ? `W${res.streakRoad.streak}`
              : `L${res.streakRoad.streak}`;

            // ===== SCORING =====
            this.gameScoring = res.scoring;

            // ===== RANKS =====
            this.homeRanks = res.ranksHome.homeRanks;
            this.roadRanks = res.ranksRoad.roadRanks;

            // ===== SCORING POSITION =====
            this.homeScoringPosition = res.scoringPosHome;
            this.roadScoringPosition = res.scoringPosRoad;

            // ===== TRELLO =====
            // this.homeInfos = res.trelloHome;
            // this.roadInfos = res.trelloRoad;
          }),
          catchError(err => {
            console.error('Erreur chargement données match', err);
            return of(null);
          })
        );
      })
    )
  );
}

  getRestColor(rest: Rest): string {
    try {
      if (rest.isBackToBack) {
        return "red";
      } else if (rest.gamesLastFourDay === 3) {
        return "orange";
      } else if (rest.gamesLastFourDay === 2) {
        return "yellow";
      } else {
        return "green";
      }
    } catch {}
  }

  getStatMuseLink() {
    // console.log('redirect to stat muse');
    window.location.href = `https://www.statmuse.com/nba/ask/${this.game.roadName}-vs-${this.game.homeName}-this-season`;
  }
}
